<template>
   <v-footer height="auto" fixed>
    <v-card class="flex" flat tile>
      <v-card-title class="brown lighten-5">
        <strong>Здоровье, победы, спортивное долголетие</strong>
        <v-spacer></v-spacer>
        <a href="tel:+79852874586">+7 (985) 287 45 86</a>
        <v-spacer></v-spacer>
        <a href="mailto:karatemayak@yandex.ru">karatemayak@yandex.ru</a>
      </v-card-title>
    </v-card>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped>
</style>
